import { useCallback, useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { GOOGLE_CLIENT_ID } from '@bo-utils/environmentVariables';
import { GoogleSignInButton } from '@prizepicks/component-library/src/components/buttons';
import { selectIsAuthenticated } from '@bo-services/authenticationSlice';
import { useGoogleLoginCallBackMutation } from '@bo-services/authenticationApi';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const OneTap = () => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const [disableOneTap, setDisableOneTap] = useState(false);
  const navigate = useNavigate();

  const [googleLoginCallBack, { isLoading, isError, isSuccess }] =
    useGoogleLoginCallBackMutation();

  const handleGoogleLogin = useCallback(() => {
    Cookies.remove('g_state');
    try {
      window.google.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID || window.backoffice.googleClientId,
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        callback: googleLoginCallBack
      });
      google.accounts.id.prompt();
    } catch (error) {
      setDisableOneTap(true);
    }
  }, [googleLoginCallBack]);

  useEffect(() => {
    if (!isAuthenticated) {
      handleGoogleLogin();
    }
  }, [handleGoogleLogin, isAuthenticated]);

  if (isSuccess) {
    navigate('/');
  }
  return (
    <div>
      <GoogleSignInButton
        disabled={isLoading || disableOneTap}
        handleOnClick={handleGoogleLogin}
      />
      {isError && <div className="text-roses">Please try again</div>}
    </div>
  );
};

export default OneTap;
